import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import SessionsListComponent from "../sessions/components/SessionsListComponent";
import { useParams } from "react-router-dom";

const AttendancesListPage = () => {
  //
  const listRef = useRef();
  const { schoolId, trainingId } = useParams();
  //
  return (
    <>
      <MeaPage
        //breadcrumb={<SlotsBreadCrumb />}
        title="Feuilles de présences"
        subtitle="Gérer l'ensemble des feuilles de présences"
      >
        <SessionsListComponent
          ref={listRef}
          schoolId={schoolId}
          trainingId={trainingId}
          showAddButton={false}
          showFilterButton={true}
          selectedFields={{
            presence: true,
            presenceStatistics: true,
          }}
        />
      </MeaPage>
    </>
  );
};
export default AttendancesListPage;
